import { render, staticRenderFns } from "./PainelProgep.vue?vue&type=template&id=6c0f1c78"
import script from "./PainelProgep.vue?vue&type=script&lang=js"
export * from "./PainelProgep.vue?vue&type=script&lang=js"
import style0 from "./PainelProgep.vue?vue&type=style&index=0&id=6c0f1c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports